import { createFileRoute } from '@tanstack/react-router';

import { ensureRecord } from '@/app/guards';
import { ForbiddenError, NotFoundView } from '@/features/shell';
import { StatementPage, statementQuery } from '@/features/staff-commission';
import { isApiError } from '@/shared/api';

export const Route = createFileRoute('/_app/staff-commission/statements/$userId/$period')({
  staticData: { crumb: 'staffCommission:nav.statements', crumbTo: '/staff-commission/statements' },
  loader: async ({ context, params }) => {
    try {
      const s = await ensureRecord(context.queryClient.query({ ...statementQuery(params.userId, params.period), staleTime: 'static' }));
      return { crumb: s.person.name };
    } catch (e) {
      // Outside the caller's scope (e.g. a salesperson opening a colleague's statement): in-shell "No access".
      if (isApiError(e) && e.isForbidden) throw new ForbiddenError('staff_commission.view', 'this statement');
      throw e;
    }
  },
  notFoundComponent: function StatementNotFound() {
    const { userId, period } = Route.useParams();
    return <NotFoundView reference={`${userId} ${period}`} />;
  },
  component: function StaffStatement() {
    const { userId, period } = Route.useParams();
    return <StatementPage userId={userId} period={period} />;
  },
});
